import React, { useEffect, useState, useMemo } from "react";
import BlockAtm from "../../../../atomic/Block/Block";
import LabelAtm from "../../../../atomic/Label/Label";
import ColAtm from "../../../../atomic/Col/Col";
import Prices from "./Prices";
import {Grid} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {setCurrency, isDefined} from "../../../../../utils";

function getSelectedPoliciesForRate(cancellationListData, roomId, rateName) {
    if (!Array.isArray(cancellationListData) || !roomId || !rateName) return [];

    const room = cancellationListData.find(r => r?.id === roomId);
    if (!room || !Array.isArray(room?.property_room_rate_mapping)) return [];

    const rateMapping = room?.property_room_rate_mapping.find(
        rm => rm?.name === rateName
    );
    if (!rateMapping || !Array.isArray(rateMapping?.room_rate_channel_cancellation_policy)) return [];

    return rateMapping?.room_rate_channel_cancellation_policy.filter(p => p?.is_selected === true);
}

export default function Accommodation(props) {
    useEffect(() => {},[]);
    const [roomRate] = useState(props.roomRate);
    const { t } = useTranslation();
    const isPerRoom = props.roomPricingTypeId === 2;

    setCurrency(roomRate.currency_code)

    const selectedPolicies = useMemo(() => {
        if (!isPerRoom) return [];
        return getSelectedPoliciesForRate(
            props?.cancellationListData,
            props?.roomId,
            roomRate?.name
        );
    }, [isPerRoom, props.cancellationListData, props.roomId, roomRate.name]);

    const policyLabels = useMemo(() => {
        if (!selectedPolicies.length) return [];
        return selectedPolicies
            .map(p => {
                const isNonRefundable = Number(p?.is_nonrefundable) === 1;
                if (isNonRefundable) return { label: t('btn-new_non_refundable_cancellation_policy'), color: '#e74c3c' };
                if (Number(p?.is_free_cancellation) === 1) return { label: t('btn-new_free_cancellation_policy'), color: '#888' };
                if (Number(p?.is_free_cancellation) === 0 && !isNonRefundable) return { label: t('btn-new_refundable_cancellation_policy'), color: '#888' };
                return null;
            })
            .filter(Boolean);
    }, [selectedPolicies, t]);

    return (
        <>
        {
                <ColAtm className="inventory-avail-box">
                        <ColAtm xs={2} >
                            <Grid item md={1}></Grid>
                            <Grid item md={1}><i className="gray fas fa-tags" /></Grid>
                            <Grid item md={10}>
                                <LabelAtm labelClass="inventory-room-name" text={roomRate.name} />
                                {isPerRoom && policyLabels.map((item, idx) => (
                                    <p key={idx} className="inventory-policy-name" style={{fontSize: '11px', color: item.color, margin: '16px 0 0 0'}}>
                                        {item.label}
                                    </p>
                                ))}
                            </Grid>
                            <BlockAtm className="channels-box" md={2}></BlockAtm>
                            <BlockAtm className="inventory-copy-box" md={3}></BlockAtm>
                        </ColAtm>
                        <ColAtm xs={10}>
                            {
                                Object.keys(roomRate.prices).map( (key) => (
                                    <Prices prices={roomRate.prices[key].price}
                                            stop_sell={roomRate.prices[key].stop_sell}
                                            min_stay={roomRate.prices[key].min_stay}
                                            priceName={t(roomRate.prices[key].language_key) + " " + t('web-offer-price')}
                                            onChangeUpdateData={props.onChangeUpdateData}
                                            updatedData={ props.updatedData }
                                            currency_code={ roomRate.currency_code }
                                            channelAvailability={ props.channelAvailability }
                                            showStopSell={ props.showStopSell }
                                            showMinStay={ props.showMinStay }
                                            isAvail={false}
                                            cancellationPolicies={isPerRoom ? selectedPolicies : []}
                                    />
                                ))
                            }
                            {

                                roomRate.hasOwnProperty('availabilities') && Object.keys(roomRate.availabilities).length > 0 &&
                                Object.keys(roomRate.availabilities).map( (key) => (
                                    <Prices prices={roomRate.availabilities[key].availability}
                                            stop_sell={roomRate.prices[key].stop_sell}
                                            min_stay={roomRate.prices[key].min_stay}
                                            priceName={ t(roomRate.availabilities[key].language_key) + " " + t('enw-room_and_rates-assign_rate-checkbox_title-availability')}
                                            onChangeUpdateData={props.onChangeUpdateData}
                                            updatedData={ props.updatedData }
                                            channelAvailability={ props.channelAvailability }
                                            showStopSell={ props.showStopSell }
                                            showMinStay={ props.showMinStay }
                                            isAvail={true}
                                    />
                                ))
                            }
                        </ColAtm>
                </ColAtm>

        }
        </>


    );
}
